import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';

Vue.use(Vuetify, {
  // Material Icons: https://material.io/tools/icons/
  iconfont: 'md' // 'md' || 'mdi' || 'fa' || 'fa4'
});
